import { decode } from 'shopify-gid'

/**
 * Google Analytics cross-domain tracking
 * Decorate the url to the new domain (checkout domain for this site) to append
 * the current domain's _ga= tracking code.
 *
 * @example
 * var thankYouUrl = "https://www.example.com/success";
 * thankYouUrl = decorateUrl(thankYouUrl);
 *
 * Output: https://www.example.com/success?_ga=2.2328371.2065749092.1631945728-748819676.1631945728
 **/

export function decorateUrl(urlString) {
  var ga = window[window['GoogleAnalyticsObject']]
  var tracker
  if (ga && typeof ga.getAll === 'function') {
    tracker = ga.getAll()[0] // Uses the first tracker created on the page
    urlString = new window.gaplugins.Linker(tracker).decorate(urlString)
  }
  return urlString
}

/**
 * Add to cart tracking
 * @args array of products
 *
 * @example
 * [
 *   {
 *     name: 'Triblend Android T-Shirt',
 *     id: '12345',
 *     price: '15.25',
 *     brand: 'Google',
 *     category: 'Apparel',
 *     variant: 'Gray',
 *     quantity: 1,
 *   },
 * ]
 **/
export const gaAddToCart = (products) => {
  // Measure adding a product to a shopping cart by using an 'add' actionFieldObject
  // and a list of productFieldObjects.
  dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
  dataLayer.push({
    event: 'addToCart',
    ecommerce: {
      currencyCode: 'USD',
      add: {
        products,
      },
    },
  })
}

export const gaProductView = (products) => {
  dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
  dataLayer.push({
    ecommerce: {
      currencyCode: 'USD', // Local currency is optional.
      impressions: products,
    },
  })
}

export const gaProductDetailView = (product) => {
  if (typeof window === 'undefined') return
  window.dataLayer = window.dataLayer || []

  const decodedProductId = decode(product.storefrontId)
  const price = product.priceRangeV2.minVariantPrice.amount

  dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
  dataLayer.push({
    ecommerce: {
      detail: {
        products: [
          {
            name: product.title, // Name or ID is required.
            id: decodedProductId.id,
            price: price,
            brand: product.vendor,
            category: product.productType,
            variant: product.variants[0].title,
          },
        ],
      },
    },
  })
}

export const gaProductClick = (product, list = undefined) => {
  if (typeof window === 'undefined') return
  window.dataLayer = window.dataLayer || []

  const decodedProductId = decode(product.storefrontId)
  const price = product.priceRangeV2.minVariantPrice.amount

  dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
  dataLayer.push({
    event: 'productClick',
    ecommerce: {
      click: {
        actionField: { list: list }, // Optional list property.
        products: [
          {
            name: product.title, // Name or ID is required.
            id: decodedProductId.id,
            price: price,
            brand: product.vendor,
            category: product.productType,
            variant: product.variants[0].title,
            position: 1,
          },
        ],
      },
    },
  })
}
